import{jsx as e}from"react/jsx-runtime";import"react";
/**
 * 새로운 기능이나 콘텐츠를 표시하기 위한 작은 원형 뱃지 컴포넌트입니다.
 *
 * @component
 * @param {Object} props - 컴포넌트 프로퍼티
 * @param {string} [props.className] - 컴포넌트에 적용할 추가 CSS 클래스명
 *
 * @example
 * // 기본 사용법
 * <NewBadge />
 *
 * // 커스텀 클래스와 함께 사용
 * <NewBadge className="custom-badge" />
 *
 * // 텍스트와 함께 사용
 * <div>
 *   새로운 기능 <NewBadge />
 * </div>
 */const t=({className:t})=>/*#__PURE__*/e("svg",{xmlns:"http://www.w3.org/2000/svg",width:"4",height:"4",viewBox:"0 0 4 4",fill:"none","data-testid":"design-system-new-badge",className:t,children:/*#__PURE__*/e("circle",{cx:"2",cy:"2",r:"2",fill:"#FF6B21"})});export{t as NewBadge};
